export const useCurrencyFormatter = (locales = [], options = { currency: 'USD' }) => {
	const _locales = Array.isArray(locales) ? locales : [locales]
	const { currency } = options

	const _options = {
		style: 'currency',
		...options,
		currency: currency || 'USD', // default to USD
	}

	let formatter
	try {
		// try to use the locale provided by the user or the default locale.
		// this prevents the formatter from throwing an error when the locale is not supported nor valid.
		formatter = new Intl.NumberFormat([..._locales, 'en-US'], _options)
	} catch (error) {
		// fallback to 'en-US'
		formatter = new Intl.NumberFormat('en-US', _options)
	}
	return formatter
}
